import { CalendarDays } from "lucide-react";
import { fmtISTDate, fmtISTTime } from "@/lib/ist";

export const SessionPicker = ({ sessions, value, onChange }) => (
  <div>
    <div className="text-sm font-medium mb-2">Pick your session *</div>
    <div role="radiogroup" className="grid gap-2" data-testid="masterclass-session-picker">
      {sessions.map((s) => {
        const full = s.seats_left <= 0;
        const active = value === s.id;
        return (
          <button
            type="button" key={s.id} role="radio" aria-checked={active} disabled={full}
            onClick={() => onChange(s.id)}
            data-testid={`masterclass-session-option-${s.id}`}
            className={`flex items-center justify-between gap-3 text-left rounded-xl border px-4 py-3 transition-colors ${
              active ? "border-navy bg-white ring-2 ring-navy/15" : "border-gray-200 bg-white hover:border-navy/40"
            } ${full ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            <span className="flex items-center gap-3">
              <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${active ? "bg-navy text-white" : "bg-gray-100 text-navy"}`}>
                <CalendarDays size={16} />
              </span>
              <span>
                <span className="block text-sm font-semibold text-navy">{fmtISTDate(s.starts_at)}</span>
                <span className="block text-xs text-gray-500">{fmtISTTime(s.starts_at)} IST · {s.duration_minutes} min · Online</span>
              </span>
            </span>
            <span className={`text-xs font-medium ${full ? "text-red-600" : s.seats_left <= 10 ? "text-amber-600" : "text-gray-500"}`}>
              {full ? "Full" : `${s.seats_left} seats left`}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);
